// src/utils/TeamNotifier.js
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../Security/firebase-config';
import { getAuth } from 'firebase/auth';
import NotificationService from './NotificationService';

/**
 * Fetches the team document, loops through its members,
 * and sends each (except the current user) the given notification.
 */
export async function notifyTeamMembersExceptActor(
  teamId,
  { type, message, payload = {} }
) {
  // 1. Load the team's `members` array
  const teamSnap = await getDoc(doc(db, 'teams', teamId));
  if (!teamSnap.exists()) return;
  const members = teamSnap.data().members || [];

  // 2. Who’s doing the action?
  const currentUid = getAuth().currentUser?.uid;

  // 3. Loop, skipping the actor
  await Promise.all(
    members
      .filter(uid => uid && uid !== currentUid)
      .map(uid =>
        NotificationService.notifyForUser(uid, { type, message, payload })
      )
  );
}
